
<form novalidate="novalidate">
  <gw-facility-tree-view class="facility-tree" *ngIf="facilities" [facilityTree]="facilities" [selectedFacility]="selectedFacility" (changeSelectedFacility)="changeSelectedFacility($event)"></gw-facility-tree-view>
</form>